import React from 'react';
import { Badge, Col, Row, Typography } from 'antd';

import { Fieldset } from 'common/components';

import './AplContactEmail.less';

const AplContactEmail = (props) => {
  const { currentContact, requestSampleData, onChangeContactEmail } = props;

  const ContactEmailList = Object.keys(requestSampleData)?.map(
    (contactEmail) => {
      return {
        contactEmail,
        isValid: requestSampleData[contactEmail]?.isValid,
        isValidEmail: requestSampleData[contactEmail]?.isValidEmail,
        email: requestSampleData[contactEmail]?.email,
      };
    }
  );

  return (
    <div className='scroller apl-contact-email' style={{ height: '100%' }}>
      <Row>
        <Typography.Text strong>Contact Email: </Typography.Text>
      </Row>
      <div style={{ paddingRight: 6 }}>
        {ContactEmailList?.map((sampleRequest, index) => {
          const isActive = currentContact === sampleRequest?.contactEmail;
          return (
            <CardContent
              key={index}
              isActive={isActive}
              sampleRequest={sampleRequest}
              onChangeContactEmail={() => {
                if (!isActive)
                  onChangeContactEmail(sampleRequest?.contactEmail);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AplContactEmail;

const CardContent = (props) => {
  const { isActive, sampleRequest, onChangeContactEmail } = props;

  const { contactEmail, isValid, isValidEmail, email } = sampleRequest || {};

  const emptyEmail =
    contactEmail === 'Empty' && !email ? 'Please enter email' : contactEmail;

  return (
    <Badge
      title='Please provide the necessary information'
      offset={[-5, 15]}
      count={!isValid || !isValidEmail ? '!' : null}
    >
      <Fieldset
        onClick={onChangeContactEmail}
        className={isActive && 'apl-contact-email__active'}
        style={{
          padding: '8px 14px 8px',
          cursor: 'pointer',
        }}
      >
        <Row>
          <Col span={24}>
            <Typography.Text
              style={{ lineHeight: 'normal' }}
              strong
              ellipsis={{ tooltip: contactEmail }}
            >
              {email || emptyEmail}
            </Typography.Text>
          </Col>
        </Row>
      </Fieldset>
    </Badge>
  );
};
